<template>
  <div v-if="initialized" class="redirect">
    <div class="pa-5">
      <div class="label font-weight-bold">
        {{$t('redirect_choose_rule')}}
      </div>
      <div class="section">
        <v-radio-group v-model="formRedirectionMode" class="radio-ctn">
          <v-radio value="stc" :label="$t('redirect_custom_landing_page')"></v-radio>
          <div class="inset font-weight-light">
            {{$t('redirect_custom_landing_page_description')}}
          </div>
          <div class="help-ctn mt-5">
            <v-radio :disabled="!isAvailable('editor:redirect:url')" value="url">
              <template slot="label">
                {{$t('redirect_redirect_one_url')}}
              </template>
            </v-radio>
            <info-tooltip class="redirect-tooltip" position="left" :content="$t('redirect_info_company_url')"></info-tooltip>
          </div>
          <div class="inset">
            <div class="font-weight-light">
              {{$t('redirect_all_qr_scans_url')}}
            </div>
            <div class="card-input-ctn">
              <v-form autocomplete="off" v-model="valid">
                <input autocomplete="false" name="hidden" type="text" style="display:none;">
                <v-text-field
                  v-model="url"
                  :label="$t('redirect_enter_url')"
                  name="url"
                  :disabled="formRedirectionMode != 'url'"
                  :rules="this.urlRules"
                  dense
                  :placeholder="$t('redirect_url_placeholder')">
                </v-text-field>
              </v-form>
            </div>
          </div>
          <div class="help-ctn">
            <v-radio :disabled="!isAvailable('editor:redirect:product')" value="product">
              <template slot="label">
                {{$t('redirect_product_specific_url')}}
              </template>
            </v-radio>
            <info-tooltip class="redirect-product-tooltip" position="left" :content="$t('redirect_info_product_url')"></info-tooltip>
          </div>
          <i18n class="inset font-weight-light" path="redirect_product_qr_description" for="product_url">
            <template #product_url>
              <a href="#" class="font-weight-bold" @click="redirectToProducts($event)">{{ $t('product_url') }}</a>
            </template>
          </i18n>
        </v-radio-group>
      </div>
    </div>
  </div>
</template>

<script>

import Api from '@/api'
import { mapGetters } from 'vuex'
import InfoTooltip from '@/components/utils/InfoTooltip.vue'
import amplitude from 'amplitude-js'

export default {
  name: 'RedirectTab',
  components: { InfoTooltip },
  computed: {
    ...mapGetters(['initialized', 'isAvailable', 'needToUpdateRedirection']),

    formRedirectionMode: {
      get () {
        return this.needToUpdateRedirection ? this.needToUpdateRedirection : this.$store.getters.redirectionMode
      },

      set (value) {
        amplitude.getInstance().logEvent(`Changed redirection to ${value}`)
        this.$store.dispatch('changeRedirectionMode', { mode: value, url: this.url })
      }
    },

    url: {
      get () {
        if (Api.default_url === this.$store.getters.redirectUrl) { return '' }
        return this.$store.getters.redirectUrl ? this.$store.getters.redirectUrl : 'https://'
      },

      set (value) {
        if (value && this.valid) {
          this.$store.dispatch('updateRedirectionUrl', value)
        }
      }
    }

  },
  data () {
    return {
      valid: false,
      urlRules: [
        v => !!v || 'URL Required.'
        // v => /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(v) || 'URL must be valid.'
      ]
    }
  },
  watch: {
    initialized (newVal) {
      if (newVal) {
        if (this.$route.name === 'redirect' && this.formRedirectionMode === 'stc') {
          this.$router.push('editor')
        }
      }
    },
    url (newVal) {
      const tmp = newVal.substr(8)
      if (tmp && tmp.indexOf('https://') === 0) {
        this.url = tmp
      }
    }
  },
  methods: {
    redirectToProducts (event) {
      event.preventDefault()
      parent.postMessage({ type: 'editor.navigation', hash: '/#/products' }, '*')
    }
  }
}

</script>

<style lang="sass" scoped>

@import '@/variables.sass'

.help-ctn
  position: relative
  padding-right: 50px

.redirect-product-tooltip, .redirect-tooltip
  position: absolute
  top: 0px
  right: 0px
  padding-left: 10px
  padding-top: 0px

.label
  text-transform: uppercase
  color: $label-grey

.card-input-ctn
  background: white
  padding: 15px 0px

.radio-ctn
  label
    color: #333 !important

.inset
  padding-left: 30px

</style>
